import gql from 'graphql-tag';
import { AssetImageSubtype } from 'src/modules/assets';

export const QUERY_TOP_SEARCHED_PRODUCTS = gql`
  query TopSearchedProduts($outputChannel: String!) {
    productsSearch(
      limit: 5
      offset: 0
      sortColumn: "ranking"
      sortDirection: "asc"
      where: { term: "", outputChannel: $outputChannel }
    ) {
      id
      name_en
      name_de
      pim_id
      slug
      assets(where: { subtype: "${AssetImageSubtype.Cutout}" }, sort: "sorting:asc", limit: 1) {
        type
        subtype
        file {
          url
        }
      }
      product_series {
        id
        name_en
        name_de
        designer {
          id
          name
        }
      }
      product_categories {
        id
        slug
      }
    }
  }
`;

export const QUERY_TOP_SEARCHED_PRODUCT_CATEGORIES = gql`
  query TopSearchedProductCategories {
    topSearchedProductCategories {
      id
      name_en
      name_de
      slug
    }
  }
`;

export const QUERY_SEARCH_FILTER_DATA = gql`
  query SearchFilters {
    productCategories: searchProductCategories {
      id
      name_en
      name_de
      slug
    }
    locationTypes: searchLocationTypes(where: { key_null: false }) {
      id
      name_en
      name_de
      slug
    }
    designers {
      id
      name
      slug
    }
  }
`;
